import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attachment",
  "use": "attachment-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"attachment\">\n  <path fillRule=\"evenodd\" d=\"M 6.91,11.904107 V 7.0141079 c 0,-1.11 0.508,-1.957 1.5900001,-1.957 1.0819999,0 1.5899999,0.848 1.5899999,1.957 v 6.1949991 c 0,1.63 -0.954,2.935 -2.5449999,2.935 -1.5900001,0 -2.545,-1.304 -2.545,-2.935 V 5.0571079 c 0,-2.152 1.3999999,-3.913 3.5,-3.913 2.0999999,0 3.4999999,1.76 3.4999999,3.913 v 5.8700001\" strokeLinejoin=\"round\" strokeLinecap=\"round\" />\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol